import React from 'react';
import { Link } from 'react-router-dom';

interface AdminPageEditBarProps {
  isAdmin: boolean;
  isEditing: boolean;
  setIsEditing: (editing: boolean) => void;
  onSave: () => Promise<void> | void;
  onCancel?: () => void;
  saving?: boolean;
  pageName?: string;
}

export const AdminPageEditBar: React.FC<AdminPageEditBarProps> = ({
  isAdmin,
  isEditing,
  setIsEditing,
  onSave,
  onCancel,
  saving = false,
  pageName = 'Página',
}) => {
  if (!isAdmin) return null;

  return (
    <div className="fixed top-20 right-4 md:right-8 z-50 flex items-center gap-2 bg-[#090014]/90 backdrop-blur-md border border-purple-500/30 p-2 rounded-2xl shadow-2xl shadow-purple-950/50">
      {!isEditing ? (
        <div className="flex items-center gap-2">
          <Link
            to="/crm/admin"
            title="Volver al Panel Administrador"
            className="px-3 py-2 bg-white/5 hover:bg-white/10 text-white/70 hover:text-white rounded-xl text-xs font-medium transition-colors flex items-center gap-1.5 border border-white/10"
          >
            <i className="ri-dashboard-line" />
            <span className="hidden sm:inline">Panel</span>
          </Link>
          <button
            onClick={() => setIsEditing(true)}
            className="px-4 py-2 bg-gradient-to-r from-purple-600 to-[#FF2DAA] hover:opacity-95 text-white rounded-xl font-semibold transition-all duration-300 flex items-center gap-2 text-xs md:text-sm shadow-lg shadow-purple-500/25 cursor-pointer"
          >
            <i className="ri-edit-circle-line text-base" />
            <span>Editar {pageName}</span>
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <div className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 bg-purple-500/10 border border-purple-500/30 rounded-xl text-xs font-semibold text-purple-300 animate-pulse">
            <span className="w-2 h-2 rounded-full bg-emerald-400" />
            <span>Modo Edición</span>
          </div>

          <button
            onClick={onSave}
            disabled={saving}
            className="px-4 py-2 bg-emerald-600 hover:bg-emerald-500 disabled:opacity-60 text-white rounded-xl font-semibold transition-all duration-300 flex items-center gap-2 text-xs md:text-sm shadow-lg shadow-emerald-600/30 cursor-pointer"
          >
            {saving ? (
              <>
                <i className="ri-loader-4-line animate-spin text-base" />
                <span>Guardando...</span>
              </>
            ) : (
              <>
                <i className="ri-save-3-line text-base" />
                <span>Guardar Cambios</span>
              </>
            )}
          </button>

          <button
            onClick={() => {
              if (onCancel) onCancel();
              setIsEditing(false);
            }}
            disabled={saving}
            className="px-3.5 py-2 bg-slate-800 hover:bg-slate-700 text-white/80 hover:text-white rounded-xl font-medium transition-colors flex items-center gap-1.5 text-xs md:text-sm border border-white/10 cursor-pointer"
          >
            <i className="ri-close-line text-base" />
            <span className="hidden sm:inline">Cancelar</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminPageEditBar;
